import { makeStyles } from '@mui/styles';
import { SignatureType } from 'queries';

const useStyles = makeStyles(() => ({
  pillContainer: {
    padding: '4px 8px',
    borderRadius: '10px',
  },
}));

type Props = {
  signatureType: SignatureType;
};

const signatureTypePills = {
  [SignatureType.NoSignature]: {
    backgroundColor: '#EFFCF4',
    color: '#11854E',
    label: 'No Signature',
  },
  [SignatureType.ESignature]: {
    backgroundColor: '#FDF1F3',
    color: '#B73B59',
    label: 'E-Signature',
  },
  [SignatureType.PhysicalSignatureNoMail]: {
    backgroundColor: '#EFF4FE',
    color: '#1169BB',
    label: 'Physical Signature',
  },
  [SignatureType.PhysicalSignatureMailRequired]: {
    backgroundColor: '#F2F4F7',
    color: '#1C2541',
    label: 'Physical Signature',
  },
  [SignatureType.PhysicalSignatureAndNotaryNoMail]: {
    backgroundColor: '#66CCFF',
    color: '#003366',
    label: 'Physical Signature + Notary',
  },
  [SignatureType.PhysicalSignatureAndNotaryMailRequired]: {
    backgroundColor: '#F8F5FE',
    color: '#5925DC',
    label: 'Physical Signature + Notary',
  },
  [SignatureType.SignatureWetOrElectronic]: {
    backgroundColor: '#FF7F50',
    color: '#F2F2F2',
    label: 'Signature (Wet or Electronic)',
  },
};

const SignatureTypePill = ({ signatureType }: Props) => {
  const classes = useStyles();
  if (!signatureType) {
    return null;
  }

  const signatureTypePill = signatureTypePills[signatureType];

  return (
    <div
      style={{ backgroundColor: signatureTypePill.backgroundColor, color: signatureTypePill.color }}
      className={classes.pillContainer}
    >
      {signatureTypePill.label}
    </div>
  );
};

export default SignatureTypePill;
